export var EventName;
(function (EventName) {
    EventName["message_created"] = "message_created";
    EventName["message_updated"] = "message_updated";
    EventName["message_deleted"] = "message_deleted";
    EventName["chat_created"] = "chat_created";
    EventName["chat_updated"] = "chat_updated";
    EventName["chat_deleted"] = "chat_deleted";
    EventName["chats_bulk_updated"] = "chats_bulk_updated";
    EventName["user_status_updated"] = "user_status_updated";
    EventName["department_created"] = "department_created";
    EventName["department_updated"] = "department_updated";
    EventName["department_deleted"] = "department_deleted";
    EventName["template_created"] = "template_created";
    EventName["template_updated"] = "template_updated";
    EventName["template_deleted"] = "template_deleted";
    EventName["quick_reply_created"] = "quick_reply_created";
    EventName["quick_reply_updated"] = "quick_reply_updated";
    EventName["quick_reply_deleted"] = "quick_reply_deleted";
    EventName["bulk_send_started"] = "bulk_send_started";
    EventName["bulk_send_progress"] = "bulk_send_progress";
    EventName["user_created"] = "user_created";
    EventName["user_updated"] = "user_updated";
    EventName["user_deleted"] = "user_deleted";
    EventName["session_deleted"] = "session_deleted";
    EventName["export_created"] = "export_created";
    EventName["export_updated"] = "export_updated";
    EventName["export_deleted"] = "export_deleted";
})(EventName || (EventName = {}));
export const PING_MSG = 'ping';
